<template>
  <div>
    <div id="container" class="sbook_st main_introduce">
      <!-- Main Visible -->
      <div class="section main_viswrap">
        <div class="inner main_vis">
          <div class="m_vis_top an_a">
            <!-- <img
              class="img"
              src="@/assets/images/svg/selfbook_intro_header.svg"
              alt="이앨리스(Ealice)에서만 가능한 새로운 출판 서비스"
            /> -->
            <span class="an_t heroName">{{
              $t('views.intro.selfbookintro.ealice4')
            }}</span>
            <h1 class="heroTitleAlt">
              {{ $t('views.intro.selfbookintro.8624') }}
            </h1>
          </div>
        </div>
      </div>

      <div class="section fill pb pt introduce_img">
        <div class="inner">
          <div class="txt">
            <div class="self icon"></div>
            <h2>
              {{ $t('views.intro.selfbookintro.ealice1') }}<br /><em>{{
                $t('views.intro.selfbookintro.8769')
              }}</em>
            </h2>
            <p>
              {{ $t('views.intro.selfbookintro.7732') }}
            </p>
          </div>
          <div class="img">
            <!-- <img src="@/assets/images/selfbook_introduce_img.jpg" alt="" /> -->
          </div>
        </div>
      </div>

      <!-- 인기 셀프북 -->
      <!--
      <div class="section full introduce_list">
        <div class="inner">
          <div class="tit_wrap">
            <div class="best icon"></div>
            <div class="tit_txt">
              <p class="blind">{{ $t('views.intro.selfbookintro.ealice3') }}</p>
            </div>
          </div>

          <div class="eplist item_columns_4 sbook">
            <div class="swipe_wrap">
              <div class="swipe_area">
                <div class="swipe_content">
                  <ul class="item_list">
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="blue"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.6713') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.4871') }}</h3>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="orange"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.309') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.9167') }}</h3>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="green"
                        >
                          <span class="meta_title"
                            >{{ $t('views.intro.selfbookintro.5877') }}</span
                          >
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <span class="meta_title"
                          >{{ $t('views.intro.selfbookintro.9304') }}</span
                        >
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="blue"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.4073') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.3166') }}</h3>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="orange"
                        >
                          <span class="meta_title"
                            >{{ $t('views.intro.selfbookintro.6400') }}</span
                          >
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <span class="meta_title"
                          >{{ $t('views.intro.selfbookintro.9129') }}</span
                        >
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="green"
                        >
                          <span class="meta_title">{{ $t('views.intro.selfbookintro.6165') }}</span>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <span class="meta_title">{{ $t('views.intro.selfbookintro.3591') }}</span>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="blue"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.5361') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.7784') }}</h3>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="orange"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.4995') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.8902') }}</h3>
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="green"
                        >
                          <span class="meta_title"
                            >{{ $t('views.intro.selfbookintro.985') }}</span
                          >
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <span class="meta_title"
                          >{{ $t('views.intro.selfbookintro.4934') }}</span
                        >
                      </div>
                    </li>
                    <li>
                      <div class="cover_wrap">
                        <div class="dim"></div>
                        <router-link
                          :to="{ name: 'store' }"
                          class="thum_wrap"
                          data-bg-color="blue"
                        >
                          <h3 class="meta_title">{{ $t('views.intro.selfbookintro.7292') }}</h3>
                        </router-link>
                      </div>
                      <div class="info_wrap">
                        <h3 class="meta_title">{{ $t('views.intro.selfbookintro.6862') }}</h3>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="swipe_nav">
                <button type="button" class="svg_swipe_prew">
                  <span class="blind">{{ $t('common.ui.previous') }}</span>
                </button>
                <button type="button" class="svg_swipe_next">
                  <span class="blind">{{ $t('common.ui.next') }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      -->

      <div class="section fill makeup_link">
        <div class="inner">
          <!--
          <ul>
            <li>
              <div class="txt">
                <p class="tit">{{ $t('views.intro.selfbookintro.7947') }}</p>
                <p class="num con_book">{{ $t('views.intro.selfbookintro.6116') }}</p>
              </div>
            </li>
            <li>
              <div class="txt">
                <p class="tit">{{ $t('views.intro.selfbookintro.5747') }}</p>
                <p class="num pro_book">{{ $t('views.intro.selfbookintro.6842') }}</p>
              </div>
            </li>
            <li>
              <div class="txt">
                <p class="tit">{{ $t('views.intro.selfbookintro.4729') }}</p>
                <p class="num writer">{{ $t('views.intro.selfbookintro.2604') }}</p>
              </div>
            </li>
          </ul>
          -->
          <div class="tit_txt an_a">
            <!-- <img
              class="img"
              src="@/assets/images/svg/svg_selfbook_introduce.svg"
              alt="나의 이야기를 이앨리스에서 전자책으로 출판하고 작가가 되어보세요"
            /> -->
            <span class="an_t heroName">{{
              $t('views.intro.selfbookintro.8850')
            }}</span>
            <h1 class="heroTitleAltBottom">
              {{ $t('views.intro.selfbookintro.6569') }}
            </h1>
          </div>
          <div class="btn_wrap">
            <div class="bdsi_f1">
              <router-link :to="{ name: 'selfbook_create' }" class="box_btn"
                ><span class="an_t">{{
                  $t('views.intro.selfbookintro.7362')
                }}</span></router-link
              >
            </div>
          </div>
        </div>
      </div>

      <!-- SelfBook - banner -->
      <!--<div class="section fill selfbook_banner_n2">
			<div class="inner">
				<div class="banner_wrap">
					<p>
						<span class="img_banner"></span>
						<span class="blind">{{ $t('views.intro.selfbookintro.455') }}</span>
					</p>
					<p>{{ $t('views.intro.selfbookintro.93') }}<br/>{{ $t('views.intro.selfbookintro.4602') }}<br/>{{ $t('views.intro.selfbookintro.pod') }}</p>
					<div class="btn_wrap">
						<a href="../셀프북이용안내페이지연결확인중.html" class="box_btn"><span class="an_t">{{ $t('views.intro.selfbookintro.7169') }}</span></a>
					</div>
				</div>
			</div>
		</div>-->
    </div>
    <!-- 헬프 데스크 START -->
    <HelpDesk />
    <!-- 헬프 데스크 END -->
  </div>
</template>

<script>
import HelpDesk from '@/components/common/HelpDesk.vue'
export default {
  name: 'SelfbookIntro',

  components: { HelpDesk },
  mounted() {
    if (
      window.location.host == 'khu.ealice.com' ||
      window.location.host == 'khu.ealice.com:8800'
    ) {
      alert('현재 준비중인 서비스입니다.')
      this.$router.push({ name: 'store' })
    }
  }
}
</script>

<style lang="scss" scoped></style>
